import React from "react";
import store from './Stores/SurveyStore';
import { observer } from "mobx-react"
import { PabsMoreInfoPanels} from "../Enums/constants"

const PreviousYearDataPanel = observer(() => {
                //<button type="button" className="btn prev-data-btn">Hold to preview {store.selectedSurvey.DataYear-1} year data</button>
    //const togglePrevDataPopup = () => {
    //    store.prevDataToggle = !store.prevDataToggle; 
    //}
    const closeAdditionalInfo = () => {
        store.additionalInfoPanel.visible = false;
    }
    const closePrevYearPanel = () => {
        store.prevYearPanel.visible = false;
    }
    const priorYear = store.currentSurvey && store.currentSurvey.DataYear
        ? store.currentSurvey.DataYear - 1
        : null;
    const renderPrevYearValue = () => {
        if (store.prevYearPanel.loading) return "Loading…";
        const value = store.prevYearPanel.value;
        if (value === null || value === "" || value === "blank") {
            return "No prior-year value on record.";
        }
        return value;
    }
    //var d = new Date();
    //var currentYear = d.getFullYear();
    //var info = PabsMoreInfoPanels.PresentationsAndGroupCounseling
    //<div className="title-strip-additional-info">Additional Info on <br /> {store.additionalInfo.names = s.replace(/([A-Z])/g, ' $1').trim()</div>
    var panel_name;
    //if (store.additionalInfoPanel) panel_name = store.additionalInfoPanel.name.replace(/([A-Z])/g, ' $1').trim();
    return (
        <React.Fragment>
            {!["home", "submit", "results", "unlock"].includes(store.currentLandedPage) && store.additionalInfoPanel.visible == true &&
                <div className="additionalInfoPanel">
                <div className="title-strip-additional-info">Additional Info on <br /> <span>{store.additionalInfoPanel.name.replace(/([A-Z])/g, ' $1').trim()}</span>
                    <span onClick={closeAdditionalInfo} className="close-button topright white">&times;</span>

                </div>

                    <div className="additionalInfoPanelContent">
                    <span dangerouslySetInnerHTML={{ __html: PabsMoreInfoPanels[store.additionalInfoPanel.name]}}></span>
                    </div>
                </div>
            }

            {!["home", "submit", "results", "unlock"].includes(store.currentLandedPage) && store.prevYearPanel.visible == true &&
                <div className="additionalInfoPanel prevYearPanel">
                    <div className="title-strip-additional-info">
                        {priorYear ? `${priorYear} Entry` : "Last Year's Entry"}
                        <br /> <span>{store.prevYearPanel.name}</span>
                        <span onClick={closePrevYearPanel} className="close-button topright white">&times;</span>
                    </div>

                    <div className="additionalInfoPanelContent prevYearPanelValue">
                        {renderPrevYearValue()}
                    </div>
                </div>
            }
        </React.Fragment>

    );
});
export default PreviousYearDataPanel;

//{
//(!store.analystMode && !store.questionMode && !["home", "submit", "results", "unlock"].includes(store.currentLandedPage)) &&
//    <div className={store.prevDataToggle ? "prev-year-data open-prev-year-data" : "prev-year-data"} >
//        <span onClick={togglePrevDataPopup} className="close-button topright">&times;</span>

//        <span className="prevValueTitle">Previous Value</span><br />
//        <span className="prevValue">{store.previousYearValue}</span>
//        <div className="title-strip" onClick={togglePrevDataPopup}>Your {store.currentSurvey.DataYear - 1} Data </div>

//    </div>
//}



//<span className="close">x</span>{store.currentLandedPage} 

//<div className="page-jump-bar">
//    <div className="title-strip">In this Section </div>
//    <a href="/#pensionPayments">Pension Payments</a>
//    <a href="#">Pension Inceptions</a>
//    <a href="#">Refunds, Withdrawals <br />and Transfers-out</a>
//    <a href="#">Purchases and Transfers-in</a>
//    <a href="#">Disability</a>

//</div>

//<div className="current-survey-info">
//    <span className="bold">Now Viewing: </span>
//    CEM Benchmarking {store.selectedSurvey.DataYear} Survey <br />

//    {store.selectedSurvey.IsReadOnly &&
//        <span className="italics bold">Note: This survey is read-only.<br /></span>
//    }

//    {store.analystMode &&
//        <span> Analyst Mode ON</span>
//    }

//    {store.questionMode &&
//        <span>Question Mode ON</span>
//    }

//</div>


//<div className="additionalInfoPanel"><b>1.  Paying (but not incepting) annuity pensions for disability, early and normal retirees and their survivors, including:</b>
//    <li>EFT processing. </li> <li>Check processing and postage. </li><li>Resolving failed, misdirected and lost payments. </li> <li>Paying, but not calculating, adjustments to pensions. For example, many systems pay retroactive adjustments to pensions initiated based on incomplete data.</li> <li>Collecting overpayments. </li> <li>The processing of return payments from annuitants. </li> <li>Stopping pension payments upon  the death of an annuitant. </li>
//    <br /> <b>2. Processing deductions from the gross pension payment. For example: </b><br /> <li>Processing and paying taxes and other governmental deductions, such as social security. </li> <li>Processing legally required deductions such as liens on wages ordered by a judge. </li> <li>Processing and effecting payment of optional deductions that the member can request, such as for health care or optional life insurance or union dues. </li> <li>Processing and mailing of check stubs or EFT payment advices. </li> <li>Processing and mailing of annual tax receipts to annuitants. </li> <li>Keeping track of the rules and regulations for deductions. </li>
//    <br /> <b>3. Confirming payment eligibility. This includes:</b> <br />
//    <li>Cross referencing pension payrolls with death records. </li> <li>Obtaining proof that someone is alive. </li> <li>Checking eligibility. </li> <br />  If a sister organization performs any of the above tasks, then the costs incurred by the sister organization should be included here and in your Total Costs. <br /><br />  <b>Do NOT include: </b><br /> <li>Maintaining banking, address and beneficiary data for retirees. These belong in 3c Data Not from Employers. </li> <li>The work of inflation adjustments. It belongs in 1b Pension Inceptions. </li>

//</div>